import React from "react";

const AlertIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.88236 14.8235C9.88236 15.9914 9.03812 16.9412 8 16.9412C6.96188 16.9412 6.11765 15.9914 6.11765 14.8235H9.88236ZM8 2.11764C10.8537 2.11764 13.1765 4.72976 13.1765 7.94118V11.6471C13.1765 12.4602 13.4494 13.2025 13.8965 13.7647H2.10259C2.55059 13.2025 2.82353 12.4602 2.82353 11.6471V7.94118C2.82353 4.72977 5.14542 2.11764 8 2.11764ZM14.1177 11.6471V7.94119C14.1177 4.32531 11.6235 1.35743 8.47059 1.08531V0H7.52942V1.0853C4.37553 1.35742 1.88236 4.3253 1.88236 7.94118V11.6471C1.88236 12.8149 1.03812 13.7647 0 13.7647V14.8235H5.17648C5.17648 16.5748 6.44236 18 8 18C9.55671 18 10.8235 16.5748 10.8235 14.8235H16V13.7647C14.9619 13.7647 14.1177 12.8149 14.1177 11.6471Z"
        fill="#3F3F3F"
      />
    </svg>
  );
};

export default AlertIcon;
